import {
  ItemTypeEnum,
  ProductTypeEnum,
  type WaxUpProduct,
  waxUpTypeConfigurationSchema,
  waxUpProductSchema,
} from "@jasper/client-models";
import {
  isTeethStepComplete,
  TeethSelectionEnum,
  type ProductWorkflowConfiguration,
} from "./ProductWorkflowConfiguration";
import { applyWaxUpTeethSelection, StepKeysEnum } from "../../steps";
import { TeethStep, WaxUpTypeStep } from "./constants";

export type WaxUpStepKey =
  typeof StepKeysEnum.teeth | typeof StepKeysEnum.waxUpType;

export const WaxUpWorkflowConfiguration: ProductWorkflowConfiguration<
  WaxUpProduct,
  WaxUpStepKey
> = {
  productType: ProductTypeEnum.waxUp,
  itemType: ItemTypeEnum.waxUp,
  steps: [
    new TeethStep({ applyTeethSelection: applyWaxUpTeethSelection }),
    new WaxUpTypeStep(),
  ],
  teethSelection: TeethSelectionEnum.MANY,
  isBulkSupported: false,

  getCompletedSteps(product) {
    const completed: WaxUpStepKey[] = [];

    if (
      isTeethStepComplete({
        teeth: product.teeth,
        teethSelection: this.teethSelection,
      })
    ) {
      completed.push(StepKeysEnum.teeth);
    }

    const items = product.items ?? [];

    if (
      items.length > 0 &&
      items.every(item => waxUpTypeConfigurationSchema.safeParse(item).success)
    ) {
      completed.push(StepKeysEnum.waxUpType);
    }

    return completed;
  },

  isValidProduct(product) {
    return waxUpProductSchema.safeParse(product).success;
  },
};
